<nz-layout class="main-container">
  <app-sidebar />
  <nz-layout class="main-layout">
    <app-header />
    <nz-content [class.mb-50]="!!supportUserData">
      <router-outlet></router-outlet>
    </nz-content>
    <div class="user-info" *ngIf="!!supportUserData">
      <p class="user-email">
        {{
          'You are logged in with Account : ' + (supportUserData.email || '')
        }}
      </p>
      <button
        class="primary-text-btn"
        nz-button
        nzType="text"
        (click)="supportUserLogOut()">
        Logout
      </button>
    </div>
  </nz-layout>
</nz-layout>
